<template>
  <v-container fluid style="max-width: 1300px">
    <div style="width: 100%; overflow-x: auto">
      <v-card class="mb-1 pa-0 cshadow" style="z-index: 7">
        <v-card-actions class="pa-0 px-2">
          <v-icon left large color="blue">mdi-filter-outline</v-icon>
          <v-checkbox
            class="ma-2 float-left ml-3"
            hide-details
            v-model="filters"
            v-for="st in status"
            :key="st.name"
            :color="st.color"
            :value="st.name"
            style=""
          >
            <template v-slot:label>
              <div
                :style="{ color: st.color }"
                style="font-size: 0.87rem; font-weight: 600"
              >
                {{ st.name + " (" + st.count + ")" }}
              </div>
            </template>
          </v-checkbox>
          <v-spacer></v-spacer>
          <v-switch
            class="mt-0"
            v-model="gridMode"
            :label="gridMode ? 'Cards' : 'Grid'"
            inset
            hide-details
          >
          </v-switch>
        </v-card-actions>
      </v-card>
    </div>
    <v-card class="cshadow" v-if="gridMode">
      <v-card-actions>
        <v-btn
        v-if="reportData.length > 0"
          color="success"
          outlined
          @click="JSONToCSVConvertor(reportData, 'List', true)"
          ><v-icon left>mdi-microsoft-excel</v-icon> EXCEL</v-btn
        >
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          solo-inverted
          flat
          dense
          hide-details
          width="100%"
          style="max-width: 400px"
        ></v-text-field>
      </v-card-actions>
      <v-data-table
        :headers="headers"
        :loading="loading"
        :items="reportData"
        :search="search"
      >
        <template v-slot:item="row">
          <tr :class="`${getColor(row.item.status_named)} lighten-5 rr`">
            <td style="width: 105px; font-weight: 600; font-size: 1rem">
              {{ row.item.app_id }}
            </td>
            <td style="width: 105px">
              <img
                :src="getImgPath(row.item.picHeadShot)"
                height="45px"
                width="45px"
                style="border-radius: 45px; margin-top: 5px"
              />
            </td>
            <td>
              <span
                style="font-weight: 600; font-size: 1.1rem; line-height: 1rem"
                >{{ row.item.fName }}
              </span>
              <br />
              {{ row.item.lName }}
            </td>
            <td style="font-weight: 600">{{ row.item.jobtype_name }}</td>
            <td style="font-weight: 600">{{ row.item.print_text }}</td>
            <td style="font-weight: 600; text-align: center">
              {{ row.item.status_named }}
            </td>
            <td style="width: 150px; text-align: center">
              <div class="text-center d-flex align-center justify-space-around">
                <v-tooltip top class="mx-1">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      large
                      color="info"
                      v-on="on"
                      @click="openViewApp(row.item.application_id)"
                    >
                      <v-icon dark>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>View Application</span>
                </v-tooltip>
                <v-btn
                  icon
                  color="success"
                  large
                  v-if="getEditAccess(row.item.status_named)"
                  @click="openEditApp(row.item.application_id)"
                >
                  <v-icon dark>mdi-pencil</v-icon>
                </v-btn>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <div class="d-flex flex-wrap justify-center mt-1" v-else>
      <v-card
        v-for="data in reportData"
        :key="data.app_id"
        width="238px"
        class="mx-2 mb-2 pt-6 pb-0 text-center cshadow rounded-lg"
      >
        <div style="min-height: 264px">
          <img
            :src="getImgPath(data.picHeadShot)"
            width="140px"
            class="rounded-lg"
          />
          <div style="font-size: 1.32rem; font-weight: 600">
            {{ data.app_id }}
          </div>
          <div style="font-weight: 600">{{ data.fName }} {{ data.lName }}</div>
          <div>{{ data.jobtype_name }}</div>
          <div>{{ data.print_text }}</div>
        </div>
        <v-card-actions
          :class="`mt-2 py-1 ${getColor(data.status_named)} lighten-5`"
        >
          <div
            :style="
              'font-weight:600;padding-left:15px;color:' +
              getColor(data.status_named)
            "
          >
            {{ data.status_named }}
          </div>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                class="mx-1"
                large
                color="info"
                v-bind="attrs"
                v-on="on"
                @click="openViewApp(data.application_id)"
              >
                <v-icon dark>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>View Application</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                class="mx-1"
                color="success"
                large
                v-bind="attrs"
                v-on="on"
                v-if="getEditAccess(data.status_named)"
                @click="openEditApp(data.application_id)"
              >
                <v-icon dark>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit Application</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </div>
    <v-dialog v-model="isViewAppOpened" fullscreen class="pa-2">
      <v-btn
        large
        outlined
        icon
        color="error"
        class="ma-5"
        @click="isViewAppOpened = false"
        style="float: right; z-index: 9000"
        ><v-icon>mdi-close</v-icon></v-btn
      >
      <LfwView
        v-if="$store.state.eventInfo.TemplateId == 1"
        :aData="cAppData"
      ></LfwView>
      <PklView
        v-else-if="$store.state.eventInfo.TemplateId == 2"
        :aData="cAppData"
      ></PklView>
      <IccTeamRegView
        v-else-if="$store.state.eventInfo.TemplateId == 11"
        :aData="cAppData"
      ></IccTeamRegView>
      <DnaEventView
        v-else-if="$store.state.eventInfo.TemplateId == 3"
        :aData="cAppData"
      ></DnaEventView>
      <SMatchView
        v-else-if="$store.state.eventInfo.TemplateId == 4"
        :aData="cAppData"
      ></SMatchView>
      <IccView
        v-else-if="$store.state.eventInfo.TemplateId == 5"
        :aData="cAppData"
      ></IccView>
      <PklWidView
        v-else-if="$store.state.eventInfo.TemplateId == 6"
        :aData="cAppData"
      ></PklWidView>
      <Ilt20View
        v-else-if="$store.state.eventInfo.TemplateId == 7"
        :aData="cAppData"
      ></Ilt20View>
      <IocView
        v-else-if="$store.state.eventInfo.TemplateId == 9"
        :aData="cAppData"
      ></IocView>
      <SuperCrossView
        v-else-if="$store.state.eventInfo.TemplateId == 10"
        :aData="cAppData"
      ></SuperCrossView>
      <NmaccView
        v-else-if="$store.state.eventInfo.TemplateId == 8"
        :aData="cAppData"
      ></NmaccView>
    </v-dialog>
  </v-container>
</template>

<script>
import LfwView from "../components/templates/lfwView";
import PklView from "../components/templates/pklView";
import DnaEventView from "../components/templates/nmaccNycView";
import SMatchView from "../components/templates/sMatchView";
import IccView from "../components/templates/iccView";
import Ilt20View from "../components/templates/ilt20View";
import PklWidView from "../components/templates/pklWidView";
import NmaccView from "../components/templates/nmaccView";
import IocView from "../components/templates/iocView";
import SuperCrossView from "../components/templates/superCrossView";
import IccTeamRegView from "../components/templates/iccform/teamRegView";

export default {
  components: {
    LfwView,
    PklView,
    DnaEventView,
    SMatchView,
    IccView,
    Ilt20View,
    PklWidView,
    NmaccView,
    IocView,
    SuperCrossView,
    IccTeamRegView
  },
  data: () => ({
    isViewAppOpened: false,
    cAppData: "",
    loading: false,
    gridMode: false,
    status: [
      { name: "Saved", count: 0, color: "#424242" },
      { name: "Submitted", count: 0, color: "teal" },
      { name: "Approved", count: 0, color: "blue" },
      { name: "Amended", count: 0, color: "brown" },
      { name: "Printed", count: 0, color: "green" },
      { name: "Rejected", count: 0, color: "red" },
    ],
    filters: [],
    reportData: [],
    allData: [],
    search: "",
    headers: [
      { text: "App No", value: "app_id" },
      { text: "Photo" },
      { text: "Name", value: "fName" },
      { text: "Designation", value: "jobtype_name" },
      { text: "Access", value: "print_text" },
      { text: "App Status", value: "status_named", align: "center" },
      { text: "Actions", align: "center" },
    ],
  }),
  mounted() {
    if(this.$store.state.eventInfo.LinkId != ''){
      this.$store.commit("logout");
      this.$router
        .push("/" + this.$store.state.eventInfo.EventUrl + "/login")
        .catch(() => {});
    }
    this.$store.commit("setPageTitle", "Application Summary");
    this.binddata();
  },
  watch: {
    filters: function () {
      if (this.filters.length > 0) {
        this.reportData = [];
        this.filters.forEach((el) => {
          var tempd = this.allData.filter((item) => item.status_named === el);
          this.reportData.push(...tempd);
        });
      } else {
        this.reportData = this.allData;
      }
    },
  },
  methods: {
    getImgPath(fileName) {
      if (fileName == "" || fileName == null) {
        return "../images/nophoto.png";
      } else {
        return this.$apiPhotoPath + "/" + fileName;
      }
    },
    getColor(val) {
      switch (val) {
        case "Saved":
          return "#424242";
        case "Submitted":
          return "teal";
        case "Approved":
          return "blue";
        case "Amended":
          return "brown";
        case "Printed":
          return "green";
        case "Rejected":
          return "red";
        default:
          return "#424242";
      }
    },
    getEditAccess: function (val) {
      if (val == "Saved") {
        return true;
      } else if (val == "Amended") {
        return true;
      } else {
        return false;
      }
    },
    openViewApp: async function (appid) {
      this.loading = true;
      await this.$axios
        .post("Application/details", { application_id: appid })
        .then((res) => {
          this.cAppData = res.data.result;
          this.cAppData.dob = this.cAppData.dob
            ? this.cAppData.dob.slice(0, 10)
            : "";
          this.isViewAppOpened = true;
          this.loading = false;
        });
    },
    openEditApp: function (appID) {
      this.$store.commit("setAppInfo", { AppMode: "Edit", AppId: appID });
      this.$router.push("/app/newapplication").catch(() => {});
    },
    binddata: async function () {
      this.loading = true;
      await this.$axios.get("Application/GetByVendor").then((res) => {
        this.allData = res.data.result;
        this.reportData = res.data.result;
        for (let index = 0; index < this.status.length; index++) {
          this.status[index].count = this.allData.filter(
            (item) => item.status_named === this.status[index].name
          ).length;
        }
        this.loading = false;
      });
    },

    JSONToCSVConvertor: function (JSONData, ReportTitle, ShowLabel) {
      var arrData =
        typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
      var CSV = "";
      //CSV += ReportTitle + "\r\n\n";
      var row = "";
      if (ShowLabel) {
        row = "";
        for (const index in arrData[0]) {
          row += index + ",";
        }

        row = row.slice(0, -1);
        CSV += row + "\r\n";
      }
      for (var i = 0; i < arrData.length; i++) {
        row = "";
        for (const index in arrData[i]) {
          row += '"' + arrData[i][index] + '",';
        }
        row.slice(0, row.length - 1);
        CSV += row + "\r\n";
      }

      if (CSV == "") {
        alert("Invalid data");
        return;
      }
      var fileName = "MyReport_";
      fileName += ReportTitle.replace(/ /g, "_");

      var uri = "data:text/csv;charset=utf-8," + escape(CSV);

      var link = document.createElement("a");
      link.href = uri;

      link.style = "visibility:hidden";
      link.download = fileName + ".csv";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>
.cshadow {
  box-shadow: 0 0 10px #e7e7e7 !important;
}
.rr:hover {
  background-color: #f5f5f5 !important;
}
</style>